import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[validatorColor]',
    standalone: false
})
export class ValidatorColorDirective {

  constructor(private el: ElementRef, private renderer: Renderer2, private ngControl: NgControl) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.updateValidationStyles(value)
  }

  private updateValidationStyles(value: string) {
    if (this.ngControl?.control) {
      const hasValidators = this.ngControl.control.validator !== null
      const isInputNotEmpty = value && value.trim().length !== 0
      if (hasValidators) {
        const matFormField = this.findMatFormFieldParent(this.el.nativeElement)
        if (matFormField) {
          if(isInputNotEmpty)
              this.renderer.addClass(matFormField, 'has-validator')
          else
            this.renderer.removeClass(matFormField, 'has-validator')
        }
      }
    }
  }

  private findMatFormFieldParent(element: HTMLElement): HTMLElement | null {
    let parentElement = element.parentElement
    while (parentElement) {
      if (parentElement.tagName.toLowerCase() === 'mat-form-field') {
        return parentElement
      }
      parentElement = parentElement.parentElement
    }
    return null
  }
}